export function parseFiniteNumber(v) {
    if (v === undefined || v === null || v === '') return null;
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
}

/**
 * Compute box plot display domain from raw range values.
 * Returns null if result or lab range is invalid/missing.
 */
export function computeBoxPlotDomain(rawResult, rawLlow, rawLhigh, rawFxlow, rawFxhigh) {
    const result = parseFiniteNumber(rawResult);
    let llow = parseFiniteNumber(rawLlow);
    let lhigh = parseFiniteNumber(rawLhigh);

    if (result === null) return null;
    if (llow === null && lhigh === null) return null;
    if (llow === null) llow = 0;
    if (lhigh === null) lhigh = llow + Math.max(2 * Math.abs(result - llow), 1);

    let fxL = parseFiniteNumber(rawFxlow);
    let fxH = parseFiniteNumber(rawFxhigh);

    if (llow !== null && lhigh !== null) {
        if ((fxH !== null && fxH < llow) || (fxL !== null && fxL > lhigh)) {
            fxL = null;
            fxH = null;
        }
    }
    if (lhigh > 0 && fxH !== null && fxH > 0) {
        const ratio = lhigh / fxH;
        if (ratio > 50 || ratio < 1 / 50) {
            fxL = null;
            fxH = null;
        }
    }

    if (fxL === null) fxL = llow;
    if (fxH === null) fxH = lhigh;

    const clamp = (v, lo, hi) => Math.max(lo, Math.min(hi, v));
    fxL = clamp(fxL, llow, lhigh);
    fxH = clamp(fxH, llow, lhigh);
    if (fxL > fxH) [fxL, fxH] = [fxH, fxL];

    const minValue = Math.min(llow, fxL, result);
    const maxValue = Math.max(lhigh, fxH, result);
    const baseSpan = Math.max(1e-9, maxValue - minValue);
    const buffer = Math.max(0.1 * baseSpan, 0.5);
    const displayMin = minValue - buffer;
    const displayMax = maxValue + buffer;

    return { result, llow, lhigh, fxL, fxH, displayMin, displayMax };
}
